import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { LanguageType } from 'types/languages';
import { getErrorMessage } from 'utilities/ErrorHelper';

export const useGetUserLanguage = () => {
  const languagesService = useServices().languagesService;
  return useQuery({
    queryKey: ['userLanguage'],
    queryFn: async () => {
      const response = await languagesService.getUserLanguage();
      localStorage.i18nextLng = response;
      return response;
    },
    refetchOnWindowFocus: false
  });
};

export const useGetLanguages = () => {
  const languagesService = useServices().languagesService;
  return useQuery({
    queryKey: ['languages'],
    queryFn: languagesService.loadLanguages,
    refetchOnWindowFocus: false
  });
};

export const useSelectLanguage = () => {
  const languagesService = useServices().languagesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: async (languageCode: LanguageType) => {
      await languagesService.changeLanguage(languageCode);
      localStorage.i18nextLng = languageCode;
      window.location.reload();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['userLanguage'] });
    },
    onError: (ex) => notificationsStore.addToast('error', getErrorMessage(ex), 'error'),
  });
};
